import type { ModulePage } from './types'

export const meetings: ModulePage = {
  slug: 'meetings',
  name: 'Meetings',
  tagline: 'Record, transcribe, and turn every client meeting into structured file notes.',
  icon: 'mic',
  colorClass: 'meeting',
  pricingModules: ['meetings'],
  featured: true,

  seo: {
    title: 'Meeting Capture & AI File Notes',
    description:
      'Record in-person and virtual client meetings, get accurate AI transcription, and turn every conversation into structured file notes and action items automatically.',
    keywords:
      'financial adviser meeting recording, AI file notes, client meeting transcription, IFA meeting notes software',
  },

  hero: {
    eyebrow: 'Meetings',
    title: 'Every meeting,',
    titleAccent: 'drafted for you',
    subtitle:
      'One tap to record in-person or virtual meetings. Accurate transcription, structured file notes, and clear action items, ready before you leave the room.',
  },

  useCases: [
    {
      icon: 'mic',
      title: 'In-person & virtual',
      body: 'Record across desktop, mobile, Apple Watch and CarPlay, or capture in-person and virtual meetings: one consistent flow whatever the meeting.',
    },
    {
      icon: 'document',
      title: 'Annual reviews',
      body: 'Walk out of a review with the file note already drafted, so the write-up no longer eats your evening.',
    },
    {
      icon: 'bolt',
      title: 'First meetings & fact finds',
      body: 'Capture everything a new client tells you and let the AI pull out the facts, goals and follow-ups you need to act on.',
    },
  ],

  benefits: [
    {
      icon: 'document',
      title: 'AI file notes',
      body: 'Structured, consistent notes generated from the transcript, in your firm’s tone, every time.',
    },
    {
      icon: 'bolt',
      title: 'Action items & insights',
      body: 'Follow-ups and commitments are extracted automatically so nothing slips between meeting and CRM.',
    },
    {
      icon: 'mic',
      title: 'Accurate transcription',
      body: 'Speaker identification and financial terminology built in, so the record actually reads like your meeting.',
    },
    {
      icon: 'shield',
      title: 'A clear record',
      body: 'Every conversation captured and stored, giving you a clear record to support your suitability and compliance processes.',
    },
  ],

  stats: [
    { value: 'Hours back', label: 'on every write-up' },
    { value: 'Same day', label: 'file notes, not next week' },
    { value: 'No', label: 'blank-page write-ups' },
  ],

  testimonial: {
    quote:
      'We have significantly reduced our workload and become much more efficient in just a few weeks. WealthSpace has streamlined our existing processes, making them faster and more effective.',
    author: 'Karen Fussell',
    role: 'Ops Director',
    company: 'OWM (Newbury)',
  },

  cta: {
    title: 'Stop typing up',
    titleAccent: 'meeting notes',
    subtitle:
      'Record your next client meeting and get a structured first-draft file note ready for you to review. Set up in minutes.',
    note: 'No credit card required to start your free trial.',
  },
}
